// Gotowe pierwsze wiadomości według rodzaju ogłoszenia (kolekcja ogłoszenia, „kupię”, wynajem).
const VEHICLE = ['Czy pojazd jest nadal dostępny?', 'Czy możliwa jest jazda próbna?', 'Czy cena podlega negocjacji?', 'Czy pojazd był bezwypadkowy?']

export const PRESETS = {
    car: ['Czy auto jest nadal dostępne?', 'Czy możliwa jest jazda próbna?', 'Czy cena podlega negocjacji?', 'Czy auto było bezwypadkowe?'],
    vehicle: VEHICLE,
    part: ['Czy część jest dostępna?', 'Czy pasuje do mojego auta?', 'Czy możliwa jest wysyłka?'],
    service: ['Jaki jest najbliższy wolny termin?', 'Ile kosztuje usługa?'],
    tool: ['Czy produkt jest dostępny?', 'Czy możliwa jest wysyłka?', 'Czy cena podlega negocjacji?'],
    rent: ['Czy pojazd jest dostępny w moim terminie?', 'Jakie są warunki wynajmu?'],
    buy: ['Mam pojazd, który może Cię zainteresować.', 'Czy ogłoszenie jest nadal aktualne?'],
    // zapytania z wizytówki firmy (dealer, serwis, części); „…?” — początek pytania do uzupełnienia
    salon: ['Czy macie w ofercie…?', 'Jakie są godziny otwarcia?', 'Czy mogę umówić się na oglądanie?', 'Czy jest możliwość finansowania (leasing, kredyt)?', 'Czy przyjmujecie auto w rozliczeniu?', 'Proszę o kontakt telefoniczny.'],
    salonService: ['Czy macie w ofercie…?', 'Jaki jest termin wykonania usługi?', 'Jakie są godziny otwarcia?', 'Proszę o kontakt telefoniczny.'],
    salonPart: ['Czy macie w ofercie…?', 'Czy część jest dostępna od ręki?', 'Jakie są godziny otwarcia?', 'Proszę o kontakt telefoniczny.'],
}

// Zestaw dla wizytówki według przeważającej grupy ogłoszeń firmy (typeCounts z oferty wizytówki).
export function salonPresetKind (typeCounts = {}) {
    const parts = typeCounts.part_ad || 0, services = typeCounts.service_ad || 0
    const vehicles = Object.entries(typeCounts).filter(([t]) => t !== 'part_ad' && t !== 'service_ad' && t !== 'tool_ad').reduce((a, [, n]) => a + n, 0)
    if (services > vehicles && services >= parts) return 'salonService'
    if (parts > vehicles && parts > services) return 'salonPart'
    return 'salon'
}

// Zestaw dla ogłoszenia: { coll, buy, rent }.
export function presetKind ({ coll, buy, rent } = {}) {
    if (buy) return 'buy'
    if (rent) return 'rent'
    if (coll === 'car_ad') return 'car'
    if (coll === 'part_ad') return 'part'
    if (coll === 'service_ad') return 'service'
    if (coll === 'tool_ad') return 'tool'
    return 'vehicle'
}

export const presetsFor = (offer) => PRESETS[presetKind(offer)]

// Tekst złożony wyłącznie z niezmienionych gotowych wiadomości (każda w osobnej linii).
export function onlyPresets (text) {
    const set = new Set(Object.values(PRESETS).flat())
    const lines = String(text || '').split('\n').map(l => l.trim()).filter(Boolean)
    return lines.length > 0 && lines.every(l => set.has(l))
}
